module.exports = __webpack_public_path__ + "static/media/AD.ee0399c5.svg";